import React from "react";
import { Link } from "react-router-dom";
import "../home/home.css";

const BlogCard = ({ slug, title, image, excerpt }) => {
  const link = `/${slug}`;

  return (
    <div className="home-fleet-card d-flex flex-column justify-content-between">
      <div className="home-fleet-card-header">
        <Link to={link}>
          <img src={image} alt={title} className="home-fleet-card-img" />
        </Link>
        <h3 className="h3-title mt-4">
          <Link to={link} className="internal-link">{title}</Link>
        </h3>
        <p className="home-fleet-card-desc mt-3">{excerpt}</p>
      </div>
      <div className="home-fleet-btn-group">
        <Link to={link} className="btn--primary">Read More</Link>
      </div>
    </div>
  );
};

export default BlogCard;
